import { render, staticRenderFns } from "./MST_SALES_OFC_ALLOC.vue?vue&type=template&id=6e363bec&scoped=true"
import script from "./MST_SALES_OFC_ALLOC.vue?vue&type=script&lang=ts"
export * from "./MST_SALES_OFC_ALLOC.vue?vue&type=script&lang=ts"
import style0 from "./MST_SALES_OFC_ALLOC.vue?vue&type=style&index=0&id=6e363bec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e363bec",
  null
  
)

export default component.exports